import { fade, scale } from 'svelte/transition';

export function fadeScale(node, params) {
    return {
        delay: params?.delay || 0,
        duration: params?.duration || 300,
        css: (t, u) => {
            const fadeCss = fade(node, params).css(t, u);
            const scaleCss = scale(node, params).css(t, u);
            return `${fadeCss}; ${scaleCss}`;
        }
    };
}